import { Typography, Box } from '@mui/material'

import { Planning } from '@/core/models/planning.model'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useNetworkMemberPermissions } from '@/pages/network/hooks/useNetworkMemberPermissions'

import { EditPlanningDialog } from '@/shared/plannings'

import { PlanningViewMode } from '../model/types'
import { PlanningCalendar } from './PlanningCalendar'
import { ShiftProposals } from './ShiftProposals'

type PlanningDetailsProps = {
  planning: Planning
  viewMode?: PlanningViewMode
}

export function PlanningDetails({ planning, viewMode = 'all' }: PlanningDetailsProps) {
  const authUser = useAppSelector(selectAuthUser)
  const { isNetworkAdmin } = useNetworkMemberPermissions({ networkId: planning.visibility === 'network' ? planning.network : undefined })
  const canManagePlanning =
    planning.createdBy?._id === authUser?._id ||
    (planning.visibility === 'network' && isNetworkAdmin) ||
    (planning.visibility === 'facility' && !!planning.facility && planning.facility === authUser?.establishment?._id)

  return (
    <>
      <Box sx={{ p: 2, display: { xs: 'none', md: 'flex' }, justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid', borderColor: 'divider' }}>
        <Typography variant="h5" component="h1">
          {planning.name}
        </Typography>
        <EditPlanningDialog planning={planning} />
      </Box>
      <Box sx={{ p: { xs: 1, md: 2 } }}>
        <ShiftProposals planning={planning} canManagePlanning={canManagePlanning} />
      </Box>
      <PlanningCalendar planning={planning} viewMode={viewMode || 'all'} />
    </>
  )
}
